import { render, staticRenderFns } from "./PracticeMemberCard.vue?vue&type=template&id=6f3a76b6"
import script from "./PracticeMemberCard.vue?vue&type=script&lang=js"
export * from "./PracticeMemberCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports